/* eslint-disable no-undef */
import mixpanel from "mixpanel-browser";

let __hasBeenInitialized = false;

const domLoadedPromise = new Promise((resolve) => {
  document.addEventListener("DOMContentLoaded", resolve);
});

async function initIfNeeded() {
  if (__hasBeenInitialized) {
    return true;
  }

  await domLoadedPromise;

  const element = document.getElementById("__mixpanel_key");
  if (element) {
    mixpanel.init(
      element.value,
      {
        record_sessions_percent: element.dataset.recordSessionsPercent || 1,
        record_mask_text_selector: '', //unmask all text elements
        record_block_selector: '' //unmask images and videos
      }
    );
    __hasBeenInitialized = true;
    return true;
  } else {
    return false;
  }
}

/**
 * Logs an event to analytics. Automatically injects the current subdomain and path
 *
 * @param {String} eventName - The name of the event to log
 * @param {Object} eventProperties - An object containing the properties of the event
 */
export async function logEvent(eventName, eventProperties = {}) {
  if (!await initIfNeeded()) { return; }

  const { subdomain, path } = getSubdomainAndPath();

  mixpanel.track(eventName, {
    ...eventProperties,
    subdomain,
    path
  });

  maybeConsoleLog(eventName, eventProperties);
}

export async function setUserProperties(userProperties) {
  if (!await initIfNeeded()) { return; }

  mixpanel.people.set(userProperties);

  maybeConsoleLog('Set user properties', userProperties);
}

export async function identify(id, userProperties = {}) {
  if (!await initIfNeeded()) { return; }

  mixpanel.identify(id);

  if (Object.keys(userProperties).length > 0) {
    setUserProperties(userProperties);
  }

  if (window.Beacon) {
    window.Beacon("identify", {
      email: userProperties['$email'],
      name: userProperties['$name'],
      "admin-link": "https://app.supercast.com/admin/users/" + id
    });
  }

  const controller = window.Stimulus.getControllerForElementAndIdentifier(document.body, 'bridge--intercom');
  if (controller) {
    controller.identify({ userId: id, email: userProperties['$email'], name: userProperties['$name'] });
  }

  maybeConsoleLog('Identify', { id });
}

export async function startSessionRecording() {
  if (!await initIfNeeded()) { return; }

  mixpanel.start_session_recording();

  maybeConsoleLog('Starting session recording');
}

/**
 * If the TLD of the the current domain is .test (i.e. we're in dev), log to the console
 */
export function maybeConsoleLog(eventName, eventProperties) {
  if (window.location.hostname.endsWith('.test')) {
    console.log(`Analytics event: ${eventName}`, eventProperties);
  }
}

/**
 * Extracts the current subdomain and path from window.location
 */
function getSubdomainAndPath() {
  const { hostname } = window.location;
  const [subdomain, ...path] = hostname.split('.');

  return {
    subdomain,
    path: path.join('.')
  };
}
